/**
 * FormCheckbox
 * ------------------------------------------------------------------------------
 * This field decorates type="checkbox" with custom checkbox.
 * Styles are handled in SCSS (forms.scss, product-filter.scss...)
 *
   * @namespace custom
 */
custom.FormCheckbox = (() => {

	function init(selector=".custom-checkbox") {
		const radioInputs = Array.from(document.querySelectorAll(selector));

		radioInputs.forEach(radio => {
			const radioLabel = radio.parentNode;
			const radioNode = document.createElement('span');
			const radioClassName = 'custom-checkbox__custom';

			radioNode.classList.add(radioClassName);

			if (radioLabel.getElementsByClassName(radioClassName).length < 1) {
				radioLabel.appendChild(radioNode);
			}
		});
	}

	return {
		init
	}

})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/form-checkbox.js